import React, { useState, useEffect } from 'react'

const Bookings = () => {

    const [enquiry, setEnquiry] = useState([]);
    const [selectedPkg, setSelectedPkg] = useState('');
    const [showPkg, setShowPkg] = useState(false);

  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await fetch('https://api.shaktitours.com/get-booking');
        const data = await response.json();

        if (response.ok) {
          setEnquiry(data);
        } else {
          console.error('Failed to fetch enquiries:', data);
        }
      } catch (error) {
        console.error('Error while fetching enquiries:', error);
      }
    };

    fetchEnquiry();
  }, []); 

  const handleShow = (enquiry) => {
    setSelectedPkg(enquiry);
    setShowPkg(true);
  }
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };


    const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  return (
    <>
                <section className='banner2-bg'>
                <div className='container text-center'>
                    <p className='subheader-text'>Tour Bookings</p>
                </div>
            </section>

      <section className='my-5'>
        <div className='container'>

          {/* <p className='sec-heading fs-5'>Enquiry Received from Site</p> */}

<div className='table-responsive'>
<table className='w-100'>
    <tr className='bg-dark text-light'>
        <th className='px-3 py-2'>S No</th>
        <th className='px-3 py-2'>Enquire On</th>
        <th className='px-3 py-2'>Name</th>
        <th className='px-3 py-2'>Mobile</th>
        {/* <th className='px-3 py-2'>Email</th> */}
        <th className='px-3 py-2'>No of Person</th>
        <th className='px-3 py-2'>Total Price</th>
        <th className='px-3 py-2'>Package Info</th>

        </tr>

                      {enquiry.length > 0 ? (
                enquiry.map((enquiries, index) => (
                  <tr key={enquiries.id}>
                    <td className='px-3 py-2'>{index + 1}</td>
        <th className='px-3 py-2'>{formatDate(enquiries.enquire_on)}</th>
                    <td className='px-3 py-2'>{enquiries.name}</td>
                    <td className='px-3 py-2'>{enquiries.mobile}</td>
                    {/* <td className='px-3 py-2'>{enquiries.email}</td> */}
                    <td className='px-3 py-2'>{enquiries.no_of_person}</td>
                    <td className='px-3 py-2'>{enquiries.total_price}</td>
        <th className='px-3 py-2 cursor-pointer' onClick={() => handleShow(enquiries)}><i class="fa-solid fa-eye"></i></th>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" className='px-3 py-2'>No Enquiry Submission</td></tr>
              )}
</table>
</div>

        </div>
      </section>

      {showPkg && (
        <>
                    <section className='dialog-outer px-4'>
              <div className='dialog-inner py-5 col-lg-6 col-md-8 col-12 mx-auto'>

<p className='fm-dm fw-semibold fs-5'>Package Details</p>
<hr />
          <p className="fw-semibold fm-dm text-success">Package Price: ₹{selectedPkg.price}</p>

<span className='bg-orange para-text px-2 py-2 text-light fw-semibold rounded'>{selectedPkg.day} Days {selectedPkg.night} Night</span>
<p className='package-point mt-4'><span>Start Point<br/>{selectedPkg.start_point}</span>
<i class="fa-solid fa-arrow-right-arrow-left fs-3 py-2 text-dark"></i><span className='text-end'>End Point<br/>{selectedPkg.dest_point}</span></p>

<p className='para-text fw-semibold'>Enquired on: {formatDateTime(selectedPkg.enquire_on)}<br />Booking on: {formatDateTime(selectedPkg.booking_on)}<br />No of Person: {selectedPkg.no_of_person}<br />Total Booking Price: ₹{selectedPkg.total_price}</p>

<button className='nav-btn bg-dark px-3 py-2' onClick={() => setShowPkg(false)}>Go Back</button>
</div>
</section>
        </>
      )}
    </>
  )
}

export default Bookings
